/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";

const getFTEApis = stores => {
  function showCoachMark(cohortId) {
    stores.appStore.setShowFTE({ cohortId });
  }

  return {
    showCoachMark
  };
};

export const registerFTEApis = stores => {
  apiFactory.registerApi(publicApiNames.FTE, clientName => getFTEApis(stores), true);
};
